import ReactGA from 'react-ga4'

export const callCustomEvent = (eventName) => {
  ReactGA.event(eventName, {
    category: eventName,
    action: eventName,
  })
}
